export const CHARACTER_LEVEL = 70;
export const MAX_TALENT_POINTS = CHARACTER_LEVEL - 9;
export const BOSS_LEVEL = CHARACTER_LEVEL + 3;

export const EXPERTISE_PER_QUARTER_PERCENT_REDUCTION = 15.77 / 4;
export const MELEE_CRIT_RATING_PER_CRIT_CHANCE = 22.08;
export const MELEE_HIT_RATING_PER_HIT_CHANCE = 15.77;
export const ARMOR_PEN_PER_PERCENT_ARMOR = 5.92;

export const SPELL_CRIT_RATING_PER_CRIT_CHANCE = 22.08;
export const SPELL_HIT_RATING_PER_HIT_CHANCE = 12.62;

export const HASTE_RATING_PER_HASTE_PERCENT = 15.779;

// Shamans, Paladins, Druids, Deathknights get more haste than everyone else, for melee.
export const SPECIAL_MELEE_HASTE_RATING_PER_HASTE_PERCENT = 12.14;

export const DEFENSE_RATING_PER_DEFENSE = 2.37;
export const MISS_DODGE_PARRY_BLOCK_CRIT_CHANCE_PER_DEFENSE = 0.04;
export const BLOCK_RATING_PER_BLOCK_CHANCE = 7.88;
export const DODGE_RATING_PER_DODGE_CHANCE = 21.76;
export const PARRY_RATING_PER_PARRY_CHANCE = 21.76;
export const RESILIENCE_RATING_PER_CRIT_REDUCTION_CHANCE = 82.0;
export const RESILIENCE_RATING_PER_CRIT_DAMAGE_REDUCTION_PERCENT = 39.4231 / 2.2;
